import React from "react";
//#region types
import { LeftMessageBubbleProps } from "models/propTypes/messagePropTypes";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { Grid } from "@mui/material";
import clsx from "clsx";
import { CSSHelper } from "utils/helpers";

const FixedMessageBubble: React.FC<LeftMessageBubbleProps> = (props) => {
  const { message } = props;

  return (
    <Grid
      item
      className={clsx(
        cssExports.messageBubble,
        cssExports.fixedBubbleContainer,
        cssExports.messageBubbleRight,
        CSSHelper.getClassByDisplayType(message.type)
      )}
    >
      {message.message}
    </Grid>
  );
};

export default FixedMessageBubble;
